import { bannerBox } from '../../../components/BannerBox/tokens/bluestone/TR';
import { deprecatedButton } from '../../../deprecated/Button/tokens/bluestone/TR';
import type { ComponentTokens } from '../types';
import { baseComponents } from './base';

export const components: ComponentTokens = {
  ...baseComponents,
  bannerBox,
  deprecatedButton,
};
